import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
// let baseUrl = '/api/kj-gy-apartment'

let api = {
  // 添加微信账户
  addWXAccount: `${baseUrl}/WXAccount/addWXAccount`,

  // 修改微信账户
  updateWXAccount: `${baseUrl}/WXAccount/updateWXAccount`,

  // 删除微信账户
  deleteWXAccountByCodes: `${baseUrl}/WXAccount/deleteWXAccountByCodes`,

  // 获取单个微信账户信息
  getWXAccountByCode: `${baseUrl}/WXAccount/getWXAccountByCode`,

  // 获取微信账户列表
  getWXAccountList: `${baseUrl}/WXAccount/getList`,

  // 获取微信账户分页
  getWXAccountPage: `${baseUrl}/WXAccount/getWXAccountPage`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/ConfigWx.js